/* eslint-disable prettier/prettier */
import { useState, useEffect, useContext } from 'react';

export const usePlayerFilterOptions = () => {
    const [loading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const filterOptions = [
        {
            key: 'goals',
            name: 'Mål'
        },
        {
            key: 'assists',
            name: 'Assist'
        },
        {
            key: 'penaltyGoals',
            name: 'Mål på straff'
        },
        {
            key: 'allCornerGoals',
            name: 'Mål på hörna'
        },
        {
            key: 'freekickGoals',
            name: 'Frisparksmål'
        },
        {
            key: 'subinGoals',
            name: 'Mål gjorda av inhoppare'
        },
        {
            key: 'yellowCards',
            name: 'Gula kort'
        },
        {
            key: 'redCards',
            name: 'Röda kort'
        },
        // {
        //     key: 'totalDistance',
        //     name: 'Löpmeter'
        // },
        // {
        //     key: 'highestSpeed',
        //     name: 'Högsta hastighet'
        // },
        // {
        //     key: 'sprints',
        //     name: 'Antal Sprint/Max löp'
        // },
        // {
        //     key: 'springDistance',
        //     name: 'Sprint distans'
        // },
        {
            key: 'shots',
            name: 'Avslut'
        },
        {
            key: 'shotsOnTarget',
            name: 'Avslut på mål'
        },
        // {
        //     key: 'shotsPostOrBar',
        //     name: 'Avslut i målramen'
        // }
    ]
    return [filterOptions, loading, error];
}